import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt
} from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">

        <div className="row footer-top">

          {/* BRAND */}
          <div className="col-md-4">
            <h4 className="footer-logo">FruitsExport</h4>
            <p className="footer-desc">
              We deliver premium quality fruits directly from exporters.
              Fresh, organic and trusted by customers across India.
            </p>
          </div>

          {/* LINKS */}
          <div className="col-md-2">
            <h6 className="footer-title">Company</h6>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/products">Products</a></li>
              <li><a href="/about">About</a></li>
              <li><a href="/support">Support</a></li>
            </ul>
          </div>

          {/* BUSINESS */}
          <div className="col-md-3">
            <h6 className="footer-title">Business</h6>
            <ul>
              
              <li>Bulk Orders</li>
              <li>Logistics</li>
              <li>Terms & Policy</li>
            </ul>
          </div>

          {/* CONTACT */}
          <div className="col-md-3">
            <h6 className="footer-title">Contact</h6>
            <p><FaMapMarkerAlt /> Maharashtra, India</p>
            <p><FaPhoneAlt /> +91 9234492624</p>
            <p><FaEnvelope /> info@mmantc.edu.in</p>

             <div className="footer-social">
  <a href="https://facebook.com" target="_blank" rel="noreferrer">
    <FaFacebookF />
  </a>
  <a href="https://instagram.com" target="_blank" rel="noreferrer">
    <FaInstagram />
  </a>
  <a href="https://twitter.com" target="_blank" rel="noreferrer">
    <FaTwitter />
  </a>
</div>
          </div>

        </div>

        {/* BOTTOM */}
        <div className="footer-bottom">
          © 2025 FruitsExport · All rights reserved · Made by <span>MMANTC TY Diploma Student</span>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
